import { render, staticRenderFns } from "./AttachmentCopyShardDialog.vue?vue&type=template&id=252f33ec&scoped=true&"
import script from "./AttachmentCopyShardDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachmentCopyShardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentCopyShardDialog.vue?vue&type=style&index=0&id=252f33ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f33ec",
  null
  
)

export default component.exports